import React, { useEffect, useState } from "react";
import axios from "axios";
import { ApiEndpoints } from "../services/ApiConstants";

function Standings() {
    const [teams, setTeams] = useState([]);

    useEffect(() => {
        const fetchTeams = () => {
            axios.get(`${ApiEndpoints.BASE_URL}${ApiEndpoints.GET_TEAMS}?page=0&size=80`)
                .then((res) => {
                    if (res.data && res.data.teams) {
                        const filtered = res.data.teams
                            .filter(t => t.teamId >= 2001 && t.teamId <= 2020)
                            .sort((a, b) => b.winCount - a.winCount);
                        setTeams(filtered);
                    }
                })
                .catch((err) => console.log("Teams error:", err));
        };
        fetchTeams();
        const interval = setInterval(fetchTeams, 30000);
        return () => clearInterval(interval);
    }, []);

    const getPoints = (team) => (team.winCount * 2) + team.drawCount;
    const getPlayed = (team) => team.winCount + team.lossCount + team.drawCount;

    return (
        <div id="section-standings" className="spanel active">
            <div className="main-wrap" style={{ padding: "18px 0" }}>
                <div className="sh">AI IPL League Table · Season 2026</div>
                <div className="stfull">
                    <table>
                        <thead>
                        <tr>
                            <th style={{ textAlign: "left", paddingLeft: "14px" }}>#</th>
                            <th>Team</th>
                            <th>P</th>
                            <th>W</th>
                            <th>L</th>
                            <th>D</th>
                            <th>Pts</th>
                        </tr>
                        </thead>
                        <tbody>
                        {teams.map((team, index) => {
                            const isLeader = index === 0;
                            const pts = getPoints(team);
                            const played = getPlayed(team);
                            return (
                                <tr key={team.teamId} className={isLeader ? "ldr" : ""}>
                                    <td style={{
                                        paddingLeft: "14px",
                                        fontFamily: "'Exo 2'",
                                        fontStyle: "italic",
                                        fontWeight: "800",
                                        fontSize: "18px",
                                        color: isLeader ? "var(--lime)" : "var(--text3)"
                                    }}>{index + 1}</td>
                                    <td>
                                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                            {team.teamPictureURL ? (
                                                <img src={team.teamPictureURL} alt={team.name}
                                                     style={{ width: "24px", height: "24px", objectFit: "contain" }}
                                                     onError={(e) => { e.target.style.display = 'none'; }} />
                                            ) : <div style={{ fontSize: "20px" }}>🏏</div>}
                                            <div>
                                                <div style={{ fontWeight: "700", color: "var(--text)", fontSize: "13px" }}>{team.name}</div>
                                            </div>
                                        </div>
                                    </td>
                                    <td>{played}</td>
                                    <td style={{ color: "var(--lime)", fontWeight: "800" }}>{team.winCount}</td>
                                    <td style={{ color: team.lossCount > team.winCount ? "var(--pink)" : "var(--text2)" }}>{team.lossCount}</td>
                                    <td>{team.drawCount}</td>
                                    <td style={{
                                        fontFamily: "'Exo 2'",
                                        fontStyle: "italic",
                                        fontWeight: "800",
                                        fontSize: "20px",
                                        color: isLeader ? "var(--lime)" : "var(--text)"
                                    }}>{pts}</td>
                                </tr>
                            );
                        })}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

export default Standings;